import { useState, useEffect, useMemo } from 'react';
import { Modal, Typography } from '@sunrun/experience-ui-components';
import { CX_PRO, RETAIL_ADVISOR } from '@sunrun/sales-experience-shared';
import { useUserProfile } from 'providers/UserProfile';
import { getRecheckUrl } from 'helpers/reCheckURL';

const RecheckVerificationPrompt = () => {
  const { userProfile, splatUserType } = useUserProfile();
  const [showModal, setShowModal] = useState(false);
  const [promptClosed, setPromptClosed] = useState(false);

  const canRecheck = useMemo(
    () => !!splatUserType && ![RETAIL_ADVISOR, CX_PRO].includes(splatUserType),
    [splatUserType],
  );

  useEffect(() => {
    if (
      userProfile?.contactId &&
      !userProfile?.recheckId &&
      !promptClosed &&
      canRecheck
    ) {
      setShowModal(true);
    }
  }, [userProfile, promptClosed, canRecheck]);

  const recheckUrl = useMemo(
    () => (userProfile ? getRecheckUrl(userProfile) : ''),
    [userProfile],
  );

  const handleClose = () => {
    setPromptClosed(true);
    setShowModal(false);
  };

  if (!showModal) {
    return null;
  }

  return (
    <div onMouseDown={(e) => e.stopPropagation()}>
      <Modal
        customModalWidth={800}
        testId="recheck-verification-prompt"
        onClose={handleClose}
        type="warning"
        title="Recheck verification required"
        secondaryButton={{
          text: 'Continue and risk losing access',
          onClick: handleClose,
        }}
        primaryButton={{
          text: 'Recheck verification',
          onClick: () => window.open(recheckUrl, '_blank', 'noreferrer'),
        }}>
        <Typography>
          Please complete your recheck verification, make sure to click link
          account at the end of the process. Failure to complete will soon
          result in losing access to sales tools.
        </Typography>
      </Modal>
    </div>
  );
};

export { RecheckVerificationPrompt };
